<!-- 角色管理-->
<template>
  <div>
    <x-role></x-role>
  </div>
</template>

<script>
import { role } from 'ant-design-vue-admin-x';
export default {
  name: 'role',
  components: { XRole: role }
};
</script>
